// Where to go after signing in. A link into the dashboard from outside it
// (the public /embedding-problems page: "Márkaprofil → A webshop címe") goes
// through /login?next=/dashboard/…; only dashboard paths are honoured, so the
// parameter can never send anyone off the portal.

const DEFAULT = '/dashboard';

export function safeNext(raw) {
  const v = typeof raw === 'string' ? raw : '';
  if (!/^\/dashboard(?:[/?#]|$)/.test(v)) return DEFAULT;
  if (/[\\\s]|\/\//.test(v)) return DEFAULT;
  return v;
}

/// The `next` of the current URL (or `search`), made safe.
export function nextFromSearch(search = typeof window !== 'undefined' ? window.location.search : '') {
  return safeNext(new URLSearchParams(search).get('next'));
}

/// /login, carrying where to come back to (nothing for the bare dashboard).
export function loginPathFor(path) {
  const next = safeNext(path);
  return next === DEFAULT ? '/login' : `/login?next=${encodeURIComponent(next)}`;
}
